import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Crown, Truck, Percent } from "lucide-react";
import { shopApi } from "@/lib/api";

const TIER_STYLES = {
  silver: { color: "text-slate-300", bg: "from-slate-500/20", border: "border-slate-400/30" },
  gold: { color: "text-yellow-400", bg: "from-yellow-500/20", border: "border-yellow-500/30" },
  platinum: { color: "text-primary", bg: "from-primary/20", border: "border-primary/30" },
};

export default function LoyaltyCard() {
  const { data } = useQuery({ queryKey: ["loyaltyMe"], queryFn: shopApi.loyaltyMe });
  if (!data) return null;
  const t = data.tier; const style = TIER_STYLES[t.key] || TIER_STYLES.silver;
  const progress = data.next_tier ? Math.min(100, (data.lifetime_spent / data.next_tier.min_spent) * 100) : 100;

  return (
    <div className={`rounded-2xl bg-gradient-to-br ${style.bg} via-card to-card border ${style.border} p-6`} data-testid="loyalty-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Crown className={`h-5 w-5 ${style.color}`} />
          <p className="text-xs uppercase tracking-widest text-muted-foreground">Your tier</p>
        </div>
        <span className={`chip ${style.color} ${style.border}`} data-testid="tier-badge">{t.name}</span>
      </div>
      <h2 className="font-display text-3xl font-bold mb-2">${data.lifetime_spent.toFixed(2)} <span className="text-sm text-muted-foreground font-normal">lifetime spent</span></h2>

      <div className="grid grid-cols-2 gap-2 mb-4 text-xs">
        <div className="flex items-center gap-2 rounded-lg bg-black/30 p-2">
          <Percent className="h-3 w-3 text-primary" />
          <span>{Math.round(t.discount * 100)}% off every order</span>
        </div>
        <div className="flex items-center gap-2 rounded-lg bg-black/30 p-2">
          <Truck className="h-3 w-3 text-primary" />
          <span>{t.free_shipping.length ? `Free ${t.free_shipping.join(", ")} shipping` : "Standard shipping $4.99"}</span>
        </div>
      </div>

      {data.next_tier ? (
        <>
          <div className="flex justify-between text-xs text-muted-foreground mb-1">
            <span>Progress to {data.next_tier.name}</span>
            <span>${data.to_next.toFixed(2)} to go</span>
          </div>
          <div className="h-2 rounded-full bg-black/40 overflow-hidden">
            <div className="h-full bg-primary transition-all" style={{ width: `${progress}%` }} data-testid="tier-progress" />
          </div>
        </>
      ) : (
        <p className="text-xs text-primary">You're at the top tier — thanks for being a NovalynxTech legend.</p>
      )}
    </div>
  );
}
